﻿// Import styles  
import './scss/site.scss'

// Setup jquery
import $ from 'jquery'
window.$ = window.jQuery = $

// Import other scripts
import 'bootstrap'
import 'jquery-validation'
import 'jquery-validation-unobtrusive'
import "datatables.net"
import "choices.js"
import "tinymce"
import "bootbox"
import "dropzone"
import "plupload"
import "filepond"
import "leaflet"

import './js/main'
import './js/headline'
import './js/headlineDetail'
import './js/material'
import './js/materialDetail'
import './js/materialIndex'
import './js/product'
import './js/productDetail'
import './js/productView'
import './js/productIndex'
import './js/forDownload'
import './js/forDownloadIndex'
import './js/forDownloadDetail'
import './js/forDownloadTypeIndex'
import './js/forDownloadTypeDetail'
import './js/forum'
import './js/forumDetail'
import './js/contact'
import './js/contactDetail'
import './js/contactIndex'
import './js/htmlContent'
import './js/htmlContentDetail'
import './js/forumIndex'
import './js/toolDetail'
import './js/menu'
import './js/home'
import './js/upload'